/* eslint-disable */
import React, { Component } from 'react';

import { Input } from 'antd';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './NumberInput.module.scss';

export default class NumberInput extends Component {
  static propTypes = {
    classNames: PropTypes.string,
    dark: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number,
    modificate: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.number,
    yearIssued: PropTypes.bool,
    dataqa: PropTypes.string,
    isTopicAddModal: PropTypes.bool,
  };

  static defaultProps = {
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value && this.state.value !== newProps.value) {
      this.setState({ value: newProps.value });
    }
  }

  handleChange = event => {
    const value = parseInt(event.target.value);
    const { name, onChange, min, max } = this.props;
    const newValue = isNaN(value) ? undefined : value;
    if ((typeof min === 'number' && newValue < min) || (typeof max === 'number' && newValue > max)) {
      return;
    }
    this.setState({ value: newValue }, onChange({ name, value: newValue }));
  };

  render() {
    const { modificate, yearIssued, dark, dataqa, ...rest } = this.props;

    return (
      <div
        className={classNames(css.NumberInput, {
          [css.dark]: dark,
          [css.modificate]: modificate,
          [css.yearIssued]: yearIssued,
        })}
      >
        <Input
          {...rest}
          data-qa={dataqa}
          type='text'
          placeholder={this.props.placeholder || ''}
          onChange={this.handleChange}
          value={this.state.value}
          maxLength={4}
          size={this.props.isTopicAddModal ? 'default' : 'large'}
        />
      </div>
    );
  }
}
